import * as msal from "@azure/msal-browser";
import {msalConfig} from "../../msalConfig";

const msalContext = new msal.PublicClientApplication(msalConfig);
export default msalContext;
